import { FetchClient } from "../../utils/fetchClient";

export async function getAngiesLeads(name = "", brandBrandId = 0, franchiseId = 0, createdOnOrAfter = "", createdOnOrBefore = "", page = 1, pageSize = 50) {
    return await FetchClient(`/data/angies-list/leads?name=${name}&brand_id=${brandBrandId}&franchise_id=${franchiseId}&created_on_or_after=${createdOnOrAfter}&created_on_or_before=${createdOnOrBefore}&page=${page}&page_size=${pageSize}`).GET({})
}

export async function getAngiesLeadById(id = 0) {
    return await FetchClient(`/data/angies-list/lead?id=${id}`).GET({})
}
